import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStart = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 57,
	height: 56,
	viewBox: "0 0 57 56",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M50.0319 32.4378C49.0955 31.9939 48.0595 31.7985 47.0232 31.7955L44.0041 31.7875L41.8982 31.782L37.7177 37.5705C37.3229 38.1169 36.5083 38.1147 36.1165 37.5661L31.9674 31.7553L31.2784 31.7535C30.4121 31.7513 29.6099 32.0228 28.9492 32.4839C29.1728 32.8063 29.3463 33.1682 29.4478 33.5656L32.9407 47.2523L46.0677 47.2874C46.2752 47.2878 46.445 47.1191 46.4453 46.9116L46.4578 42.2696C46.4593 41.7884 46.8497 41.3998 47.3313 41.4012C47.8125 41.4023 48.2011 41.7932 48.2 42.2744L48.1876 46.916C48.1843 48.0848 47.2318 49.0326 46.0629 49.0293L33.3855 48.9953L34.6917 54.1134L39.5473 54.1262L50.6475 54.1562C52.4764 54.161 53.9629 52.6822 53.968 50.8532L54.0006 38.6947C54.0075 36.0837 52.5299 33.6216 50.0319 32.4378Z",
			fill: "url(#paint0_linear_2676_23172)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M50.0319 32.4378C49.0955 31.9939 48.0595 31.7985 47.0232 31.7955L44.0041 31.7875L41.8982 31.782L37.7177 37.5705C37.3229 38.1169 36.5083 38.1147 36.1165 37.5661L31.9674 31.7553L31.2784 31.7535C30.4121 31.7513 29.6099 32.0228 28.9492 32.4839C29.1728 32.8063 29.3463 33.1682 29.4478 33.5656L32.9407 47.2523L46.0677 47.2874C46.2752 47.2878 46.445 47.1191 46.4453 46.9116L46.4578 42.2696C46.4593 41.7884 46.8497 41.3998 47.3313 41.4012C47.8125 41.4023 48.2011 41.7932 48.2 42.2744L48.1876 46.916C48.1843 48.0848 47.2318 49.0326 46.0629 49.0293L33.3855 48.9953L34.6917 54.1134L39.5473 54.1262L50.6475 54.1562C52.4764 54.161 53.9629 52.6822 53.968 50.8532L54.0006 38.6947C54.0075 36.0837 52.5299 33.6216 50.0319 32.4378Z",
			fill: "black",
			fillOpacity: .25
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.5905 36.3357C27.2769 35.1749 26.1718 34.3614 24.904 34.3577L5.5597 34.3061C4.39697 34.3029 3.54387 35.3377 3.83162 36.4026L8.17461 52.476C8.42392 53.3989 9.30229 54.0456 10.31 54.0485L32.3924 54.1074L27.5905 36.3357Z",
			fill: "url(#paint1_linear_2676_23172)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.5905 36.3357C27.2769 35.1749 26.1718 34.3614 24.904 34.3577L5.5597 34.3061C4.39697 34.3029 3.54387 35.3377 3.83162 36.4026L8.17461 52.476C8.42392 53.3989 9.30229 54.0456 10.31 54.0485L32.3924 54.1074L27.5905 36.3357Z",
			fill: "black",
			fillOpacity: .25
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.5781 22.3942C29.5781 26.5342 32.9344 29.8906 37.0744 29.8906C41.2145 29.8906 44.5706 26.5342 44.5706 22.3942C44.5706 18.2539 41.2145 14.8979 37.0744 14.8979C32.9344 14.8979 29.5781 18.2539 29.5781 22.3942Z",
			fill: "url(#paint2_linear_2676_23172)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.5781 22.3942C29.5781 26.5342 32.9344 29.8906 37.0744 29.8906C41.2145 29.8906 44.5706 26.5342 44.5706 22.3942C44.5706 18.2539 41.2145 14.8979 37.0744 14.8979C32.9344 14.8979 29.5781 18.2539 29.5781 22.3942Z",
			fill: "black",
			fillOpacity: .25
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.44575 7.21361C6.14201 7.51771 5.64883 7.51809 5.3445 7.21399C5.34435 7.21399 5.34421 7.21361 5.34378 7.21361L3.78639 5.65579C3.48205 5.35206 3.48191 4.85876 3.78581 4.55429C3.78596 4.55429 3.7861 4.55394 3.78639 4.55394C4.09 4.25203 4.58074 4.25203 4.88435 4.55394L5.89683 5.56248L8.47844 2.98073C6.87002 1.55355 4.40906 1.69992 2.98146 3.30862C1.554 4.91731 1.70094 7.37829 3.30938 8.80547C4.91781 10.233 7.3789 10.0863 8.80622 8.47796C9.25622 7.97076 9.56613 7.35524 9.70508 6.69178C9.8819 5.86621 9.78211 5.00551 9.4206 4.24215L6.44575 7.21361Z",
			fill: "url(#paint3_linear_2676_23172)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.4434 4.4635V7.32227H35.7981V4.4635H11.4434Z",
			fill: "url(#paint4_linear_2676_23172)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.44575 17.9263C6.14201 18.2308 5.64883 18.2308 5.3445 17.9267C5.34435 17.9267 5.34421 17.9267 5.34378 17.9263L3.78639 16.3689C3.48205 16.0648 3.48191 15.5718 3.78581 15.2674C3.78596 15.267 3.7861 15.2666 3.78639 15.2666C4.09 14.9647 4.58074 14.9647 4.88435 15.2666L5.89683 16.2752L8.47844 13.6934C6.87002 12.2663 4.40906 12.413 2.98146 14.0213C1.554 15.63 1.70094 18.091 3.30938 19.5185C4.91781 20.9457 7.3789 20.7994 8.80622 19.1907C9.25622 18.6835 9.56613 18.0679 9.70508 17.4045C9.8819 16.5789 9.78211 15.7182 9.4206 14.9552L6.44575 17.9263Z",
			fill: "url(#paint5_linear_2676_23172)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.4434 18.0352H26.5495V15.176H11.4434V18.0352Z",
			fill: "url(#paint6_linear_2676_23172)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.44575 28.6352C6.14201 28.9396 5.64883 28.9396 5.3445 28.6359C5.34435 28.6355 5.34421 28.6355 5.34378 28.6352L3.78639 27.0777C3.48205 26.7736 3.48191 26.2807 3.78581 25.9762C3.78596 25.9762 3.7861 25.9758 3.78639 25.9758C4.09 25.6739 4.58074 25.6739 4.88435 25.9758L5.89683 26.9844L8.47844 24.4026C6.87002 22.9751 4.40906 23.1218 2.98146 24.7305C1.554 26.3389 1.70094 28.7998 3.30938 30.2274C4.91781 31.6549 7.3789 31.5082 8.80622 29.8995C9.25622 29.3927 9.56613 28.7768 9.70508 28.1133C9.8819 27.2878 9.78211 26.4271 9.4206 25.6644L6.44575 28.6352Z",
			fill: "url(#paint7_linear_2676_23172)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.4434 28.7441H26.5495V25.8854H11.4434V28.7441Z",
			fill: "url(#paint8_linear_2676_23172)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_2676_23172",
				x1: 30.6274,
				y1: 58.9635,
				x2: 42.6745,
				y2: 31.004,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#0186BF" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#01BFA7"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_2676_23172",
				x1: 5.69238,
				y1: 58.3565,
				x2: 14.4838,
				y2: 31.9866,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#0186BF" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#01BFA7"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_2676_23172",
				x1: 30.5824,
				y1: 33.1078,
				x2: 39.2579,
				y2: 15.1025,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#0186BF" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#01BFA7"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_2676_23172",
				x1: 2.52186,
				y1: 11.4583,
				x2: 7.02729,
				y2: 2.10436,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#0C7BAA" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#049986"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint4_linear_2676_23172",
				x1: 13.0748,
				y1: 7.93571,
				x2: 13.3133,
				y2: 3.71896,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#0C7BAA" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#049986"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint5_linear_2676_23172",
				x1: 2.52186,
				y1: 22.1712,
				x2: 7.02734,
				y2: 12.8172,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#0C7BAA" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#049986"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint6_linear_2676_23172",
				x1: 12.4553,
				y1: 18.6487,
				x2: 12.8379,
				y2: 14.4528,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#0C7BAA" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#049986"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint7_linear_2676_23172",
				x1: 2.52186,
				y1: 32.8802,
				x2: 7.02739,
				y2: 23.5262,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#0C7BAA" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#049986"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint8_linear_2676_23172",
				x1: 12.4553,
				y1: 29.3576,
				x2: 12.8378,
				y2: 25.1622,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#0C7BAA" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#049986"
				})]
			})
		] })
	]
});
export default SvgStart;
